import { StyleSheet } from 'react-native';
import colors, { appTheme } from '@/config/colors';

export const styles = StyleSheet.create({
  fullHeight: {
    flex: 1,
    flexDirection: 'column',
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    paddingTop: 10,
    paddingHorizontal: 10,
    marginHorizontal: 'auto',
  },
  statusText: {
    fontSize: 18,
    paddingTop: 10,
    textAlign: 'center',
  },
  heading: {
    paddingTop: 25,
    fontSize: 20,
    paddingBottom: 20,
    textAlign: 'center',
  },
  consentContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    paddingBottom: 10,
  },
  textMargin: {
    marginTop: 10,
  },
  text: {
    fontSize: 16,
  },
  textSmall: {
    fontSize: 14,
  },
  textCenter: {
    textAlign: 'center',
  },
  textGreen: {
    color: colors.green,
  },
  textRed: {
    color: colors.red,
  },
  epaContainer: {
    marginTop: 20,
    marginBottom: 20,
    alignSelf: 'center',
  },
  itemsCenter: {
    alignItems: 'center',
  },
  linkToConsents: {
    fontWeight: 'bold',
  },
  button: {
    backgroundColor: appTheme.primary,
  },
  buttonStyle: {
    backgroundColor: appTheme.primary,
    borderRadius: 8,
    padding: 15,
    marginVertical: 10,
  },
  buttonTextStyle: {
    color: colors.white,
    textAlign: 'center',
    fontWeight: '700',
  },
});
